import { GameId } from ".";

export const gameTitles: Record<GameId, string> = {
  cs: "CS2",
  dota: "Dota 2",
  supercell: "BLAST Bash",
  gaming: "Gaming",
};
